import SearchBar from "../../../components/searchBar/searchBar";
import type { SupportTicketListEntry } from "../supportTicketTypes";
import SupportTicketList from "./supportTicketList";

/**
 * Props for {@link SupportSidebar}.
 */
interface SupportSidebarProps {
  /** Ticket rows shown in the sidebar list. */
  tickets: SupportTicketListEntry[];
  /** Currently selected ticket id. */
  selectedTicketId: string;
  /** Whether a ticket search request is in flight. */
  searching: boolean;
  /** Error message from the ticket list request, if any. */
  error: string | null;
  /** Called when the user submits a sidebar search query. */
  onSearchTickets: (query: string) => void | Promise<void>;
  /** Called when the user selects a ticket row. */
  onSelectTicket: (ticketId: string) => void;
}

/**
 * Sidebar for the support tickets page with search and ticket list.
 *
 * @param props - Ticket list data, selection state, and fetch status.
 * @returns Support ticket sidebar with search and notification list.
 */
const SupportSidebar = ({
  tickets,
  selectedTicketId,
  searching,
  error,
  onSearchTickets,
  onSelectTicket,
}: SupportSidebarProps) => {
  return (
    <div className="support-tickets-sidebar flex h-full min-h-0 w-full flex-col overflow-hidden px-4 py-4">
      <SearchBar
        placeHolder="Search by name, authorisation ID"
        onSearchClick={(searchText) => {
          void onSearchTickets(searchText);
        }}
        id="support-tickets-search"
        isDisabled={searching}
      />
      <div className="support-tickets-sidebar-list mt-3 min-h-0 flex-1 overflow-hidden">
        <SupportTicketList
          className="h-full"
          tickets={tickets}
          selectedId={selectedTicketId}
          loading={searching}
          error={error}
          onSelect={onSelectTicket}
        />
      </div>
    </div>
  );
};

export default SupportSidebar;
